export default {
  path: 'system-safety',
  name: 'system-safety',
  meta: {
    title: '系统安全',
    icon: 'el-icon-s-help',
  },
  component: () => import('@/components/system-safety/index.vue'),
  children: [{
    path: 'data-backup',
    name: 'data-backup',
    meta: {
      title: '数据备份',
      icon: 'el-icon-set-up',
    },
    component: () => import(
      '@/components/system-safety/data-backup.vue'
    ),
  },
  {
    path: 'access-control',
    name: 'access-control',
    meta: {
      title: '访问控制',
      icon: 'el-icon-money',
    },
    component: () => import(
      '@/components/system-safety/access-strategy-list.vue'
    ),
  },
  {
    path: 'system-log',
    name: 'system-log',
    meta: {
      title: '系统日志',
      icon: 'el-icon-data-line',
    },
    component: () => import(
      '@/components/system-safety/system-log.vue'
    ),
  },
  {
    path: 'monitor',
    name: 'monitor',
    meta: {
      title: '服务器监控',
      icon: 'el-icon-s-platform',
    },
    component: () => import('@/components/system-safety/monitor.vue'),
  }],
};
